module.exports = __webpack_public_path__ + "e6a91bf3a2993c220355bc3db633de8b.pdf";